import React, { useMemo, useState } from 'react';
import { QUICK_REPLIES, QuickReply } from './QUICK_REPLIES';

interface Props {
  onSelect: (message: string) => void;
  replies?: QuickReply[];
}

export const QuickRepliesPanel: React.FC<Props> = ({ onSelect, replies }) => {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('Todos');

  const sourceReplies = replies && replies.length > 0 ? replies : QUICK_REPLIES;

  const categories = ['Todos'].concat(
    Array.from(new Set(sourceReplies.map(item => item.category))),
  );
  const filteredReplies = useMemo(
    () =>
      sourceReplies.filter(item => {
        const matchCategory = category === 'Todos' || item.category === category;
        const matchSearch =
          item.title.toLowerCase().includes(search.toLowerCase()) ||
          item.message.toLowerCase().includes(search.toLowerCase());

        return matchCategory && matchSearch;
      }),
    [search, category, sourceReplies],
  );

  return (
    <div className="quick-replies-panel">
      <h6>Respostas rápidas</h6>

      <div className="quick-replies-toolbar">
        <input
          className="quick-replies-search"
          type="text"
          placeholder="Buscar resposta..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        <select
          className="quick-replies-select"
          value={category}
          onChange={e => setCategory(e.target.value)}
        >
          {categories.map(item => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      <div className="quick-replies-list">
        {filteredReplies.map(reply => (
          <button
            key={reply.id}
            type="button"
            className="quick-reply-item"
            onClick={() => onSelect(reply.message)}
          >
            <strong>{reply.title}</strong>
            <span>{reply.category}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
